/**
 * Created by Ning Jiang on 6/25/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {IScreenConfig, ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FruitsGameModuleConfig} from "../../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../../FruitsSoundConfig";
import {FruitsGameMode} from "../../../gamemode/FruitsGameMode";
import {FruitsReelPartAnimator} from "../../../reel/reel/FruitsReelPartAnimator";
import {FruitsParsedGameData} from "../../../server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "../../../server/data/FruitsParsedInitData";
import {IFruitsParsedServerData} from "../../../server/data/FruitsParsedServerData";

export class BonusGameIntroController extends ScreenController {

    protected _isRestoreBonusGame:boolean = false;
    protected _isBonusGameWon:boolean = false;
    private _isBonusTriggeredThisSpin:boolean;
    private _gameData:IFruitsParsedServerData;
    private _numberOfBonusSpinsPlayed:number;
    private _isRestoreBonusGameFirstSpin:boolean;
    private _isFirstSpin:boolean;
    private _isStarted:boolean = false;
    private _collectedScatters:number = 0;
    private _scatterPositionsBefore:boolean[][];
    private _scatterPositions:boolean[];

    constructor(config:IScreenConfig) {
        super("BonusGameIntro", config, true);
    }

    //TODO-hevar: handle when isRestore and gameMode is Sticky while nextmode is Bonus.

    protected calculateIsTriggered(data:FruitsParsedInitData | FruitsParsedGameData):boolean {

        this._isStarted = false;
        const isRestoreState:boolean = (data instanceof FruitsParsedInitData) ? (<FruitsParsedInitData>data).isRestoreState : false;

        this._scatterPositionsBefore = (data instanceof FruitsParsedInitData) ? (<FruitsParsedInitData>data).bonusOverlayPositionsBefore : (<FruitsParsedGameData>data).bonusOverlayPositionsAfter;

        this._scatterPositions = [];
        for(let i = 0; i < this._scatterPositionsBefore.length; i++) {
            for(let j = 0; j < this._scatterPositionsBefore[i].length; j++) {
                this._scatterPositions.push(this._scatterPositionsBefore[i][j]);
            }
        }

        this._numberOfBonusSpinsPlayed = data.bonusSpinsPlayed;
        this._isBonusTriggeredThisSpin = data.isBonusTriggeredThisSpin;
        this._isRestoreBonusGame = isRestoreState && (data.bonusSpinsLeft != null && data.bonusSpinsLeft > 0) && (data.mode === FruitsGameMode.BONUS_GAME && data.nextMode === FruitsGameMode.BONUS_GAME);

        this._isFirstSpin = (data.bonusSpinsLeft != null && data.bonusSpinsLeft > 0) && this._numberOfBonusSpinsPlayed === 0;
        this._isRestoreBonusGameFirstSpin = this._isRestoreBonusGame && this._numberOfBonusSpinsPlayed === 0;

        this._isBonusGameWon = data.isBonusTriggeredThisSpin != null ? data.isBonusTriggeredThisSpin : false;
        this._gameData = data;
        if(data.isBonusTriggeredThisSpin && data.isStickyRespinTriggeredThisSpin && data.nextMode !== FruitsGameMode.BONUS_GAME) {
            return false;
        }

        this._collectedScatters = (data instanceof FruitsParsedInitData) ? (<FruitsParsedInitData>data).collectedScattersBefore : (<FruitsParsedGameData>data).collectedScatterAfter;

        if(data.mode === FruitsGameMode.STICKY_RESPIN && data.nextMode === FruitsGameMode.BONUS_GAME) {
            this._isBonusGameWon = true;
            return true;
        }


        return this._isBonusGameWon || this._isRestoreBonusGame;
    }

    public start():void {
        if(!this._isStarted) {
            this._isStarted = true;
            FruitsGameModuleConfig.stickyRespinOverlayView.initiateVisualObjects();
            FruitsGameModuleConfig.bonusOverlayView.resetScatterFrames();
            EventHandler.dispatchEvent(new GameEvent(FruitsReelPartAnimator.REPLACE_X, false));
            super.start();
        }
    }

    protected show():boolean {
        super.show();
        SlotGame.keypad.setZeroBetSpinCounter((<IFruitsParsedServerData>this._serverData!).bonusSpinsLeft);
        return this._isBonusGameWon || this._isRestoreBonusGameFirstSpin;
    }

    protected shouldShow():boolean {
        return this._isBonusGameWon || this._isRestoreBonusGameFirstSpin;
    }

    protected onCloseComplete():void {
        FruitsGameModuleConfig.preIntroScreenViewBit.fadeOutBackground();
        FruitsGameModuleConfig.bonusOverlayView.initiateVisualObjects();
        FruitsGameModuleConfig.bonusOverlayView.startIndicator();
        FruitsGameModuleConfig.bonusGameController.startBonusRound(this._scatterPositions, this._collectedScatters);
        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
        super.onCloseComplete();
    }

    private showIntro():boolean {
        return this._isBonusTriggeredThisSpin || this._isFirstSpin;
    }

    private isRestoreAndTriggeredThisSpin():boolean {
        return (this._isBonusTriggeredThisSpin && this._isRestoreBonusGame) || this._isRestoreBonusGameFirstSpin;
    }

    protected doTransitions():void {
        // Tell the reelArea to change the reel indexes, and symbols, and next reelsets, balabala...

        if(this._isRestoreBonusGame) {
            BonusGameIntroController.changeAmbientSound();
        }

        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {
            newMode : this._serverData!.nextMode,
            animate : this.shouldShow(),
            showIntro : this.showIntro(),
            isRestoreAndTriggered : this.isRestoreAndTriggeredThisSpin()
        }));

        /*
        if (this._serverData instanceof FruitsParsedInitData) {
            if((<FruitsParsedInitData>this._serverData).isRestoreState) {
                EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {
                    newMode : this._serverData!.nextMode,
                    animate : this.shouldShow(),
                    isIntro : true

                }));
            }
        }
        */
    }

    private static changeAmbientSound() {

        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.playAmbience(FruitsSoundConfig.instance.BONUS_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 0);

    }


}